import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { getApplicationSettings } from './functions'
import { ApplicationSettings } from './types'

const settings = {
    GetApplicationSettings: {
        useQuery: <TData = ApplicationSettings>(
            options?: Omit<UseQueryOptions<ApplicationSettings, AxiosError, TData>, 'queryKey' | 'queryFn'>
        ) =>
            useQuery({
                queryKey: ['applicationSettings'],
                queryFn: getApplicationSettings,
                staleTime: Infinity,
                ...options,
            }),
    },
}

export default settings
